<template>
    <div>
        <!-- 资产配置 -->
        <el-tabs v-model="activeColumn" type="border-card" class="tabs-card-one" @tab-click="activeChange">
<!--            <el-tab-pane name="one" label="等权重">-->
<!--                <equalWeight></equalWeight>-->
<!--            </el-tab-pane>-->
<!--            <el-tab-pane name="two" label="均值方差">-->
<!--                <weightCalculation @getCode="getCode"></weightCalculation>-->
<!--            </el-tab-pane>-->
<!--            <el-tab-pane name="three" label="风险平价">-->
<!--                <riskEvaluation @riskCode="riskCode"></riskEvaluation>-->
<!--            </el-tab-pane>-->
<!--            <el-tab-pane name="four" label="CAPM模型">-->
<!--                <modelCAPM></modelCAPM>-->
<!--            </el-tab-pane>-->
<!--            <el-tab-pane name="five" label="BL模型">-->
<!--                <modelBL></modelBL>-->
<!--            </el-tab-pane>-->
            <el-tab-pane name="six" label="模拟组合">
                <analogCombinationDetails></analogCombinationDetails>
            </el-tab-pane>
        </el-tabs>
        <combination :key="timer" v-if="(activeColumn=='two'&&fundcode.weightcode!='') || (activeColumn=='three'&&fundcode.riskcode!='')" :fundcode="fundcode" :active="activeColumn"></combination>
    </div>
</template>

<script>
import equalWeight from "./equalWeight.vue"
import weightCalculation from "./weightCalculation.vue"
import riskEvaluation from "./riskEvaluation.vue"
import modelCAPM from "./modelCAPM.vue"
import modelBL from "./modelBL.vue"
import analogCombinationDetails from "./analogCombinationDetails.vue"
import combination from "./combination.vue"

export default {
    name: "analogCombination",
    components: {
        // equalWeight,
        // weightCalculation,
        // riskEvaluation,
        analogCombinationDetails,
        // modelCAPM,
        // modelBL,
        combination
    },
    data() {
        return {
            activeColumn: 'six',
            fundcode: {
                weightcode: '',
                riskcode: '',
            },
            timer: ''
        }
    },
    methods: {
        activeChange(tab) {
            this.timer = new Date().getTime();//解决父组件点击后子组件页面内容不更新
        },
        getCode(val) {
            this.fundcode.weightcode = val
            this.timer = new Date().getTime();
        },
        riskCode(val) {
            this.fundcode.riskcode = val
            this.timer = new Date().getTime();
        }
    }
}
</script>

<style scoped lang="less">
</style>